import { storyblokEditable, renderRichText } from "@storyblok/react";

const TextBlock = ({ blok }) => {
  return (  
    <div {...storyblokEditable(blok)} className="block-text">
       <div dangerouslySetInnerHTML={{ __html: renderRichText(blok.textblock) }} />
    </div>
  );
};

export default TextBlock;